export const Header = () => {
  return (
    <div className="w-full sticky-header py-2 font-light text-xs text-white bg-lime-600 z-10">
      <div className="container">
        <div className="marquee-wrapper overflow-hidden">
          <div className="animate-marquee-wrapper flex">
            <div className="animate-marquee whitespace-nowrap animate-marquee-1">
              Selamat datang di Jakarta Open Trail Run (JOTR) – bagian resmi
              Kejurda ALTI DKI Jakarta untuk mencari atlet terbaik menuju PON
              2028.
            </div>
            <div className="animate-marquee whitespace-nowrap animate-marquee-2 ml-96">
              JOTR adalah ajang trail run kompetitif yang memadukan latihan
              alam, gaya hidup sehat, dan pengembangan ekosistem olahraga
              outdoor di Jakarta.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
